import { useState, useEffect } from 'react';

import {
  createUserNPS,
  updateUserNPS,
  streamUserNPS,
} from 'Util/FirebaseService/FirestoreService/PreferenceNPSContent';
import { useAuthenticationFirebase } from 'Context/FirebaseAuthenticationContext';

// current NPS content state of users
export const NPS_STATE = {
  COMPLETE: 'COMPLETE', // user has completed feedback
  // integer (0-n): user has skip n times
};

const defaultNPSState = 0;

function isNPSStateCorrect(npsState) {
  return npsState === NPS_STATE.COMPLETE || (Number.isInteger(npsState) && npsState >= 0);
}

const useNPSState = ({ courseCode }) => {
  const [currentNPSState, setNPSState] = useState(null);
  const { user: firebaseUser, isFirebaseInitialize } = useAuthenticationFirebase();

  useEffect(() => {
    if (isFirebaseInitialize && firebaseUser && courseCode !== '' && courseCode !== undefined) {
      const unsubscribe = streamUserNPS(firebaseUser.id, {
        next: (docSnapshot) => {
          const docData = docSnapshot.data();
          if (!docSnapshot.exists) {
            createUserNPS(firebaseUser.id, courseCode, defaultNPSState);
          } else if (!(courseCode in docData) || !isNPSStateCorrect(docData[courseCode])) {
            updateUserNPS(firebaseUser.id, courseCode, defaultNPSState);
          } else {
            setNPSState(docData[courseCode]);
          }
        },
        error: (err) => {
          console.warn(err);
        },
      });
      return unsubscribe;
    }
  }, [courseCode, firebaseUser]);

  const updateNPSState = (nextFeedback) => {
    if (isNPSStateCorrect(nextFeedback)) {
      updateUserNPS(firebaseUser.id, courseCode, nextFeedback);
    }
  };

  return [currentNPSState, updateNPSState];
};

export default useNPSState;
